import { createStore } from 'vuex';
import { Views } from '../utilities/enums';

export default createStore({
  state: {
    view: Views.List,
    darkTheme: false,
  },
  mutations: {
    setView(state, view) {
      state.view = view;
      localStorage.setItem('view', view);
    },
    setDarkTheme(state, dark) {
      if (dark) {
        state.darkTheme = true;
        document.documentElement.classList.add('dark');
      } else {
        state.darkTheme = false;
        document.documentElement.classList.remove('dark');
      }
      localStorage.setItem('theme', dark ? 'dark' : 'light');
    },
  },
  actions: {
    init({ commit }) {
      // Initialize view:
      commit('setView', parseInt(localStorage.getItem('view'), 10) || Views.List);
      // Initialize theme:
      const savedTheme = localStorage.getItem('theme');
      if (savedTheme === null) {
        commit('setDarkTheme', window.matchMedia('(prefers-color-scheme: dark)').matches);
      } else {
        commit('setDarkTheme', savedTheme === 'dark');
      }
    },
    toggleDarkTheme({ commit, state }) {
      commit('setDarkTheme', !state.darkTheme);
    },
  },
});
